import { VIcon, VMenu } from "vuetify/components";
import type { Campaign } from "~/entities/Campaign";
import AtomsMenuPopup from "~/components/Atoms/MenuPopup.vue";

type handleActionType = (val: any, item: Campaign) => void;

export const tableHeaders = (handleAction: handleActionType) => {
  return [
    // sp row 1
    {
      label: "オファータイトル",
      key: "campaignTitle",
      hideTitleSp: true,
      sortable: false,
      align: "left",
      width: 25,
      spAlign: "left",
      spWidth: 90,
      render: (item: Campaign) => {
        return h("div", { class: "w-100 text-left" }, item.campaignTitle);
      },
    },
    // sp row 2
    {
      label: "対象プラン",
      key: "targetPlan",
      sortable: false,
      align: "center",
      width: 20,
      spAlign: "center",
      spWidth: 50,
      render: (item: Campaign) => {
        return [
          h("div", `ID: ${item.displayPlanPrice.planPriceId}`),
          h("div", { class: "text-center" }, item.displayPlanPrice.priceName),
        ];
      },
    },
    // sp row 2
    {
      label: "オファープラン",
      key: "offerPlan",
      sortable: false,
      align: "left",
      width: 15,
      spAlign: "center",
      spWidth: 50,
      render: (item: Campaign) => {
        return [h("div", `ID: ${item.offerPlanPrice.planPriceId}`), h("div", item.offerPlanPrice.priceName)];
      },
    },
    // sp row 3
    {
      label: "成約数",
      key: "dealCount",
      sortable: false,
      align: "center",
      width: 15,
      spAlign: "center",
      spWidth: 50,
      render: (item: Campaign) => {
        return item.contractUserCount;
      },
    },
    // sp row 3
    {
      label: "ステータス",
      key: "status",
      sortable: false,
      align: "center",
      width: 15,
      spAlign: "center",
      spWidth: 50,
      render: (item: Campaign) => {
        return item.status === "AVAILABLE" ? "稼働中" : "停止中";
      },
    },
    // sp row 3
    {
      label: "",
      key: "action",
      sortable: false,
      align: "center",
      width: 15,
      spAlign: "center",
      spWidth: 10,
      render: (item: Campaign) => {
        return h(
          VMenu,
          { location: "bottom" },
          {
            activator: ({ props }: any) => h(VIcon, { icon: "$mdiDotsVertical", ...props }),
            default: () =>
              h(AtomsMenuPopup, {
                list: [
                  { text: "変更する", value: "edit-item" },
                  { text: "変更履歴", value: "edit-history" },
                  { text: "削除する", value: "delete-item" },
                ],
                "onUpdate:selected": (val: any) => handleAction(val, item),
              }),
          },
        );
      },
    },
  ];
};

export const spRows = () => {
  return [
    [{ key: "campaignTitle" }, { key: "action" }],
    [{ key: "targetPlan" }, { key: "offerPlan" }],
    [{ key: "dealCount" }, { key: "status" }],
  ];
};
